import { fork } from 'redux-saga/effects';
import watchChangeCurrency from './watchChangeCurrency';

export default function* watchCurrency() {
  yield fork(watchChangeCurrency);
}
